module.exports = __webpack_public_path__ + "img/17_93.762f8295.png";